import axios from "axios";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { API_URL } from "../utils";
import TranslatedText from "../Translate/TranslatedText";
import { TranslationContext } from "../context/TranslationContext";
import usePlaceholders from "../constants";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState();
  const [message, setMessage] = useState();
  const [errors, setErrors] = useState({});
  const [contactUsData, setContactUsData] = useState({});

  const { enterYourEmail } = usePlaceholders();

  const [openIndex, setOpenIndex] = useState(null);

  const navigate = useNavigate();

  const toggleMenu = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const menuData = [
    {
      title: t("sicily"),
      links: [
        t("noto"),
        t("licata"),
        t("mazaraDelVallo"),
        t("cefalu"),
        t("messina"),
      ],
    },
    {
      title: t("sardinia"),
      links: [t("olbia"), t("cagliari")],
    },
    {
      title: t("naples"),
      links: [t("naples")],
    },
  ];

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const validated = () => {
    let formErrors = {};
    let valid = true;
    if (!email) {
      formErrors.email = t("emailRequired");
      valid = false;
    } else if (!emailRegex.test(email)) {
      formErrors.email = t("invalidEmail");
      valid = false;
    }

    setErrors(formErrors);
    return valid;
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validated()) {
      return;
    }

    const data = {
      email,
    };
    try {
      const lang = localStorage.getItem("appLanguage") || "en";
      const response = axios.post(
        `${API_URL}/newlatter/store?lng=${lang}&language=${lang}`,
        data,
      );
      if ((response.status = 200)) {
        setEmail("");
        // setMessage("Success");
        navigate("thank-you");
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const getContactUs = async () => {
    try {
      const lang = localStorage.getItem("appLanguage") || "en";
      const response = await axios.get(
        `${API_URL}/contactus/get-contactus-settings?lng=${lang}&language=${lang}`,
      );
      if ((response.status = 200)) {
        setContactUsData(response.data.result);
      }
    } catch (error) {
      console.log(error.message);
    }
  };
  useEffect(() => {
    getContactUs();
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <div className="backtop">
        <button id="back-to-top" onClick={scrollToTop}>
          <img
            src="/assets/images/Icon-long-arrow.svg"
            alt=""
            className="img-fluid"
          />
        </button>
      </div>

      <footer>
        <div className="container">
          <div className="row">
            <div className="col-lg-5 col-md-5 px-lg-0">
              <div className="footer-logo mb-lg-5 pb-lg-4 mb-md-5 pb-md-4 mb-4 pb-2">
                <a href="">
                  <img
                    src="/assets/images/f-logo.svg"
                    alt=""
                    className="img-fluid"
                  />
                </a>
              </div>
              <div className="footer-newletter mb-lg-5 pb-lg-4 mb-md-5 pb-md-4 mb-4 pb-2">
                <div className="newsletter-desc">
                  <p>
                    {/* <TranslatedText>
                      Want to be the first to know
                    </TranslatedText> */}
                    {t("want_to_be_first")}
                    <br></br>
                    {/* <TranslatedText>
                      about the latest great travel deals?
                    </TranslatedText> */}
                    {t("about_travel_deals")}
                  </p>
                </div>
                <div className="newsletter-form">
                  <form onSubmit={handleSubmit}>
                    <div className="mb-3 inner-newsform">
                      <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="form-control"
                        id="exampleInputEmail1"
                        placeholder={enterYourEmail}
                      />
                      <button
                        type="submit"
                        className="btn btn-primary btn-style3"
                      >
                        {/* <TranslatedText>Submit</TranslatedText> */}
                        {t("submit")}
                      </button>
                    </div>
                  </form>
                </div>
                {message && <p className="text-success">{message}</p>}
                {errors && errors.email && (
                  <p className="text-danger">{errors.email}</p>
                )}
              </div>
              <div className="footer-socials mb-lg-0  mb-md-0 mb-4">
                <div className="socials-title">
                  <h4>
                    {/* <TranslatedText>Follow Us On</TranslatedText> */}
                    {t("follow_us")}
                  </h4>
                </div>
                <div className="social-links">
                  <a
                    href="https://www.facebook.com/kiwitravelitaly/"
                    target="blank"
                  >
                    <img
                      src="/assets/images/facebook.svg"
                      alt=""
                      className="img-fluid me-3"
                    />
                  </a>
                  <a
                    href="https://www.instagram.com/kiwitravelitaly?igsh=ZGV4eW84YXd1dXEz&utm_source=qr"
                    target="blank"
                  >
                    <img
                      src="/assets/images/instagram.svg"
                      alt=""
                      className="img-fluid me-3"
                    />
                  </a>
                  <a
                    href="https://www.linkedin.com/company/kiwi-travel-s-r-l/?viewAsMember=true"
                    target="blank"
                  >
                    <img
                      src="/assets/images/linkedin.svg"
                      alt=""
                      className="img-fluid me-3"
                    />
                  </a>
                  {/* <a href="#">
                    <img
                      src="assets/images/youtube.svg"
                      alt=""
                      className="img-fluid me-3"
                    />
                  </a> */}
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 px-lg-0 footer-left-column">
              <div className="footer-quicklinks">
                <h3 className="footer-title">
                  {/* <TranslatedText>Destinations</TranslatedText> */}
                  {t("destinations")}
                </h3>
                <ul className="quicklinks-wrap">
                  {menuData.map((item, index) => (
                    <li
                      key={index}
                      className={`mb-3 menu-item-has-children ${
                        openIndex === index ? "open" : "closed"
                      }`}
                    >
                      <Link
                        to={`/destinations-list`}
                        state={{ selectedTab: item.title }}
                      >
                        {item.title}
                      </Link>

                      <div
                        className={`sub-menu ${
                          openIndex === index ? "active" : "inactive"
                        }`}
                        style={{
                          display: openIndex === index ? "block" : "none",
                        }}
                      >
                        <ul className="submenu-footer-quicklinks">
                          {item.links.map((link, i) => (
                            <li key={i}>
                              <Link to={`/destinations-list`}>{link}</Link>
                            </li>
                          ))}
                        </ul>
                      </div>

                      <span
                        className="arrow-icon"
                        onClick={() => toggleMenu(index)}
                        style={{ cursor: "pointer" }}
                      >
                        <i className="kiwi-arrow-angle" />
                      </span>
                    </li>
                  ))}
                </ul>
                <br /> {/* Company Information */}
                <div className="footer-loc-wrap footer-company-info">
                  <h4>Kiwi Travel s.r.l.</h4>

                  <p>
                    <strong>{t("Footer Add1")}</strong>
                    <br />
                    {t("Footer Add2")}
                    <br /> {t("Footer Add3")}
                    <br />
                    {t("Footer Add4")}
                    <br />
                    {t("Footer Add5")}
                  </p>

                  <p>
                    <strong>{t("Footer Add6")}</strong>
                    <br />
                    {t("Footer Add7")}

                    <br />
                    {t("Footer Add8")}
                  </p>

                  <p>
                    <strong>{t("Footer Add9")}</strong>
                    <br />
                    {t("Footer Add10")}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 px-lg-0 ">
              <div className="footer-lastrow">
                <div className="footer-quicklinks mb-4 mb-lg-5 mb-md-5">
                  <h3 className="footer-title">KIWI Travel</h3>
                  <ul className="quicklinks-wrap">
                    <li className="mb-2">
                      <Link to={"/about-us"}>
                        {/* <TranslatedText>About Us</TranslatedText> */}
                        {t("about_us")}
                      </Link>
                    </li>
                    <li className="mb-2">
                      <Link to={"/contact-us"}>
                        {/* <TranslatedText>Contact Us</TranslatedText> */}
                        {t("contact_us")}
                      </Link>
                    </li>
                    <li className="mb-2">
                      <Link to={"/terms-and-conditions"}>
                        {/* <TranslatedText>Terms and Condition</TranslatedText> */}
                        {t("terms_and_conditions")}
                      </Link>
                    </li>
                    <li className="mb-2">
                      <Link to={"privacy-policy"}>
                        {/* <TranslatedText>Privacy and Policy</TranslatedText> */}
                        {t("privacy_policy")}
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="footer-getintouch mb-4 mb-lg-5 mb-md-5">
                  <h3 className="footer-title">
                    {/* <TranslatedText>Get in Touch</TranslatedText> */}
                    {t("get_in_touch")}
                  </h3>
                  <div className="footer-contactDetails">
                    <div className="email-address mb-3">
                      <a
                        href={`mailto:${contactUsData && contactUsData.email}`}
                      >
                        {contactUsData && contactUsData.email}
                      </a>
                    </div>
                    <div className="phone-number">
                      {/* <a href="tel:+39 0931969812" className="mb-3">
                        <img
                          src="assets/images/add_call.svg"
                          alt=""
                          className="pe-2"
                        />
                        <TranslatedText>
                          {contactUsData && contactUsData.phone}
                        </TranslatedText>
                      </a> */}
                      <a
                        href={`tel:+${
                          contactUsData && contactUsData.whatsapp_number
                        }`}
                      >
                        <img
                          src="assets/images/add_call.svg"
                          alt=""
                          className="pe-2"
                        />
                        {/* <TranslatedText>
                          {contactUsData && contactUsData.whatsapp_number}
                        </TranslatedText> */}
                        {t(contactUsData && contactUsData.whatsapp_number)}
                      </a>
                    </div>
                  </div>
                </div>
                <div className="footer-address">
                  <h3 className="footer-title">
                    {/* <TranslatedText>Location</TranslatedText> */}
                    {/* {t("main office")} */}
                  </h3>
                  <div className="footer-loc-wrap">
                    {/* <TranslatedText>
                      {contactUsData && contactUsData.address}
                    </TranslatedText> */}
                    {/* {t(contactUsData && contactUsData.address)} */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row mx-0">
          <div className="col-lg-12 col-md-12 px-lg-0 mt-5 pb-3 footer-copy-wrapper">
            <div className="copy-footer-bottom">
              <div className="left-content">
                <p>© 2025 Kiwi Travel</p>
              </div>
              <div className="right-content text-lg-end text-md-end">
                <p>
                  {/* <TranslatedText>Design and Developed by</TranslatedText>{" "} */}
                  {t("design_developed_by")}{" "}
                  <a href="#" target="_blank">
                    idigitalise
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};
export default Footer;
